"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const settingsTranslations = {
    groupSettings: "Group Settings",
    hideChat: "Hide Chat",
    confirmHideChat: "Are you sure you want to make this chat hidden?",
    hide: "Hide",
    unhide: "Unhide",
    hideGroupSuccessMessage: "group hidden successfully",
    unhideChat: "Unhide Chat",
    confirmUnhideChat: "Are you sure you want to make this chat active?",
    unhideGroupSuccessMessage: "group unhidden successfully",
    muteNotifications: "Mute Notification",
    userSettings: {
        settings: "Settings",
        doNotDisturb: "Do Not Disturb (DND)",
        notifications: "Notifications",
        addUser: "Add user",
        addPatient: "Add patient",
        help: "Help",
        aboutUs: "About us",
        version: "Version",
    },
    notifications: {
        general: "General",
        alertSound: "Alert Sound",
        muteNotifications: "Mute Notifications",
        patientGroups: "Patient Groups",
        allNotifications: "All Notifications",
        importantNotifications: "Important Notifications",
        noNotifications: "No Notifications",
        internalGroups: "Internal Groups",
        directMessages: "Direct Messages",
    },
    securitySettings: {
        resetPin: "Reset Pin Lock",
    },
    organizationMedia: {
        loading: "Loading",
        noItemsFound: "No items found",
        tryDifferentKeywords: "Try searching with different keywords",
        forwardTitle: "Forward",
        forwardConfirm: "Forward {{count}} item(s)?",
        forward: "Forward",
        cancel: "Cancel",
        select: "Select",
        selectAll: "Select All",
        deselectAll: "Deselect All",
        selectedCount: "{{count}} selected",
        emptyImagesVideosDescription: "Uploaded images and videos will appear here.",
        fetchingSharedMedia: "Fetching shared media",
        emptyDocumentsDescription: "Uploaded documents will appear here.",
        fetchingSharedDocuments: "Fetching shared documents",
    },
};
exports.default = settingsTranslations;
